import { Span } from 'elements/Text';

const Loader = ({
  isLoading,
  children,
  isReady = true, 
  ...restProps
}) => isReady
  ? (isLoading
    ? <Span {...restProps}>Loading...</Span>
    : <>{ children }</>)
  : <Span {...restProps}>No Content</Span>;

export default Loader;
